import React, {useEffect, useState} from 'react';

// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Form,
  Input,
  Row,
  CustomInput,
  Col
} from "reactstrap";
import axios from "axios";
import { RCS_CAMPAIGN,CHANNEL_CLIENT_CHNLTYPE,FETCH_GROUP_NAMES } from "../../constants";
import SampleCSV from "./sample.csv"
import NotificationAlert from "react-notification-alert";
import moment from "moment";
import LoadingScreen from "react-loading-screen";
import logo from "../../assets/img/logo.png";

var initialValues ={
  file: "",
  name: "",
  message: "",
  date:moment().format("YYYY-MM-DD HH:mm A"),
  templateid:"",
  templateType:"",
  senderid:"",
  priority1:{
    templateid:"",
    channel:"",
    senderid:""
  },
  priority2:{
    templateid:"",
    channel:"",
    senderid:""
  },
  priority3:{
    templateid:"",
    channel:"",
    senderid:""
  },
  priority4: {
    templateid: "",
    channel: "",
    senderid: "",
  }
}
let templates = [];
let senderids = [];
let groups = [];


let smstemplates = [];
let smssenderids = [];

let rcstemplates = [];
let rcssenderids = [];

let emailtemplates = [];
let emailsenderids = [];

let ivrtemplates = [];
let ivrsenderids = [];
var channels =[
  {
    value: "",
    label: "Select Channel",
    isDisabled: true,
  },
  { value: 'SMS', label: "SMS" },
  { value: 'Email', label: "Email" },
  { value: 'Whatsapp', label: "Whatsapp" },
  { value: "IVR", label: "IVR" },
];

let userObj = localStorage.getItem("user");
const password = localStorage.getItem("password");

let user = JSON.parse(userObj);
const Createcampaigns = () => {


  const [rcsCampaign, setRcsCampaign] = useState(initialValues);

  const [validation, setValidation] = useState({ isvalid: false, message: "" });
  const notificationAlertRef = React.useRef(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [channel, setChannel] = useState([]);
  const [channelsms, setChannelsms] = useState([]);
  const [channelemail, setChannelemail] = useState([]);
  const [channelrcs, setChannelrcs] = useState([]);
  const [channelivr, setChannelivr] = useState([]);
  const [errorhandle,setErrorHandle]= useState();
  const [iscalbck, setiscalbck] = useState(false);
  const [ismanual,setIsManual] = useState(0)
  const [error,setError] = useState({
    error:"",
    iserror:false
  })

  useEffect(()=>{
    fetchChanelsbyClient();
    fetchSmsChanelsbyClient();
    fetchEmailChanelsbyClient();
    fetchIvrChanelsbyClient();
    fetchRcsChanelsbyClient();
    viewGroupList();

  },[])

  const viewGroupList = (pageNo) => {
    let lcObj = localStorage.getItem("user");
    let lclStrge = JSON.parse(lcObj);
    let clientid=lclStrge?.client;
    let user_id=lclStrge?.user_id;

    axios
      .get(`${FETCH_GROUP_NAMES}?user_id=${user_id}`)
      .then((response) => {
        groups=[]
        response?.data?.message?.map((group,i)=>{
          
          group?.name&&groups.push({ value:group?.name, label: group?.name })
         
       })
        setIsLoading(false)
      })
      .catch((error) => {
        console.log("????", error);
      });
  };

  const fetchChanelsbyClient=async()=>{
    setIsLoading(true)

    const payload={
      channels_type:"rcs",
      clintId:user?.client
    }
    user?.client!=0&&(await axios.post(CHANNEL_CLIENT_CHNLTYPE,payload).then(res=>{
    
      if(res?.data){
      templates=[]
      
     
      
      //setRcsCampaign(res?.data)
      setChannel(res?.data)

      res?.data?.map((wtsap,i)=>{
        wtsap?.template&&templates.push({ value:wtsap?.template, label: wtsap?.template })
       
     })
    }
      setIsLoading(false)
     }).catch(e=>{
     
      let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
    }))

  }

  
   //Fetching Template by RCS Channel

   const fetchRcsChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "whatsapp",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          rcstemplates = [];
          const chnlObj = res?.data[0];

          setChannelrcs(res?.data);
        //  setRcsCampaign({ ...rcsCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              rcstemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          console.log("Error---",e);
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };


   //Fetching Template by IVR Channel

   const fetchIvrChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "ivr",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          ivrtemplates = [];
          const chnlObj = res?.data[0];

          setChannelivr(res?.data);
         // setRcsCampaign({ ...rcsCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              ivrtemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };

    //Fetching Template by SMS Channel

    const fetchSmsChanelsbyClient = async () => {
      setIsLoading(true);
  
      const payload = {
        channels_type: "sms",
        clintId: user?.client,
      };
      user?.client != 0 &&
        (await axios
          .post(CHANNEL_CLIENT_CHNLTYPE, payload)
          .then((res) => {
            smstemplates = [];
            const chnlObj = res?.data[0];
  
            setChannelsms(res?.data);
           // setRcsCampaign({ ...rcsCampaign, peid: chnlObj.peid });
  
            res?.data?.map((item, i) => {
              item?.template &&
                smstemplates.push({ value: item?.template, label: item?.template });
            });
  
            setIsLoading(false);
          })
          .catch((e) => {
            let options = {};
            options = {
              place: "tr",
              message: e.code,
              type: "warning",
              autoDismiss: 2,
            };
            notificationAlertRef?.current?.notificationAlert(options);
          }));
    };

      //Fetching Template by Email Channel

  const fetchEmailChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "email",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          emailtemplates = [];
          const chnlObj = res?.data[0];
       
          setChannelemail(res?.data);
        //  setsmsCampaign({ ...smsCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              emailtemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };


  const changeSender=(data)=>{
    senderids=[]
    const chnl=channel.filter(item=>item.template==data.value)
      
    const senderid = chnl[0]?.senderid?.split(",");
        for(let i=0;i<senderid?.length;i++){
          senderids.push({label:senderid[i],value:senderid[i]})
        }
    setRcsCampaign(prev=>({...prev,templateid:data,senderid:"",message: chnl[0]?.content,templateType: chnl[0]?.sms_type}))

  }

  const fetchSenderId=(data,chnl)=>{
    if(chnl==="SMS")
    {
     smssenderids = [];
     const chnls = channelsms?.filter((item) => item.template == data.value);
     const senderid = chnls[0]?.senderid?.split(",");
     for (let i = 0; i < senderid?.length; i++) {
      smssenderids.push({ label: senderid[i], value: senderid[i] });
     }
   }
   else if(chnl=="Email"){
    emailsenderids = [];
    const chnls = channelemail?.filter((item) => item.template == data.value);
    const senderid = chnls[0]?.senderid?.split(",");
    for (let i = 0; i < senderid?.length; i++) {
      emailsenderids.push({ label: senderid[i], value: senderid[i] });
    }
   }
   else if(chnl=="RCS"){
     rcssenderids = [];
     const chnls = channelrcs?.filter((item) => item.template == data.value);
     const senderid = chnls[0]?.senderid?.split(",");
     for (let i = 0; i < senderid?.length; i++) {
       rcssenderids.push({ label: senderid[i], value: senderid[i] });
     }
   }
    else if(chnl=="IVR"){
     ivrsenderids = [];
     const chnls = channelivr?.filter((item) => item.template == data.value);
     const senderid = chnls[0]?.senderid?.split(",");
     for (let i = 0; i < senderid?.length; i++) {
       ivrsenderids.push({ label: senderid[i], value: senderid[i] });
     }
   }
  
  

 }

 const checkvalue = (value, priority) => {
  if (priority == "priority1") {
    if (rcsCampaign?.priority2?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority2",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign?.priority1, channel: "",templateid:"",senderid:"" },
      }));
    } else if (rcsCampaign?.priority3?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority3",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign?.priority1, channel: "",templateid:"",senderid:"" },
      }));
    }else if (rcsCampaign?.priority4?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority4",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign?.priority1, channel: "" ,templateid:"",senderid:""},
      }));
    } else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign?.priority1, channel: value ,templateid:"",senderid:""},
      }));
    }
  } else if (priority == "priority2") {
    if (rcsCampaign?.priority1?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority1",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign?.priority2, channel: "",templateid:"",senderid:"" },
      }));
    } else if (rcsCampaign?.priority3?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority3",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign?.priority2, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (rcsCampaign?.priority4?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority4",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign?.priority2, channel: "",templateid:"",senderid:"" },
      }));
    } else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign?.priority2, channel: value,templateid:"",senderid:"" },
      }));
    }
  } else if (priority == "priority3") {
    if (rcsCampaign?.priority1?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority1",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign?.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (rcsCampaign?.priority2?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority2",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign?.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (rcsCampaign?.priority4?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority4",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign?.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    }
     else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign?.priority3, channel: value ,templateid:"",senderid:""},
      }));
    }
  } else if (priority == "priority4") {
    if (rcsCampaign?.priority1?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority1",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign?.priority4, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (rcsCampaign?.priority2?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority2",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign?.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    }  else if (rcsCampaign?.priority3?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority3",
        value,
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign?.priority4, channel: "" ,templateid:"",senderid:""},
      }));
    } 
    
    else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setRcsCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign?.priority4, channel: value,templateid:"",senderid:"" },
      }));
    }
  }
};

 const submitWhatsapp = () =>{
  
  const isValid = validate()
  setErrorHandle(isValid)
  if(Object.keys(isValid).length==0){
    setIsLoading(true);
    let slctddate = "";
    if(moment(rcsCampaign.date).format("YYYY-MM-DD HH:mm") != "Invalid date"){
      slctddate = moment(rcsCampaign.date).format("YYYY-MM-DD HH:mm");
    }else{
      slctddate =rcsCampaign.date.slice(0,-2) ;
    }
    const formData = new FormData();
    formData.append("file", rcsCampaign.file);
    formData.append("name", rcsCampaign.name);
    formData.append('date', slctddate);
    formData.append("user_id",user?.user_id)
    formData.append("client_id",user?.client)
    formData.append("username",user?.username)
    formData.append("password",password)
    formData.append("senderid",rcsCampaign.senderid?.value)
    formData.append("message", rcsCampaign?.message)
    formData.append('template',  rcsCampaign.templateid?.value);
    formData.append('template_type',  rcsCampaign?.templateType);

    formData.append('priority1',  rcsCampaign?.priority1?.channel);
    formData.append('templateid1',  rcsCampaign?.priority1?.templateid?.value);
    formData.append('senderid1',  rcsCampaign?.priority1?.senderid?.value);
    formData.append('priority2',  rcsCampaign?.priority2?.channel);
    formData.append('templateid2',  rcsCampaign?.priority2?.templateid?.value);
    formData.append('senderid2',  rcsCampaign?.priority2?.senderid?.value);
    
    formData.append('priority3',  rcsCampaign?.priority3?.channel);
    formData.append('templateid3',  rcsCampaign?.priority3?.templateid?.value);
    formData.append('senderid3',  rcsCampaign?.priority3?.senderid?.value);

    
    formData.append('priority4',  rcsCampaign.priority4?.channel?.value);
    formData.append('templateid4',  rcsCampaign.priority4?.templateid?.value);
    formData.append('senderid4',  rcsCampaign.priority4?.senderid?.value);



    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    axios
      .post(RCS_CAMPAIGN, formData, config)
      .then((response) => {
        setIsLoading(false)
        let options = {};
        options = {
          place: "tr",
          message: "Submitted Successfully",
          type: "success",

          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
       
        setRcsCampaign(initialValues)
       
      })
      .catch((err) => console.log("err==>", err));
      setIsLoading(false)
  }
  
  }

  const validate=()=>{
    const onlylettersRegex =/^[a-zA-Z ]+$/;
    let errors={}
    if(!rcsCampaign.name){
      errors.name="Please Enter Name"
    } else if(rcsCampaign?.name?.length<=3){
      errors.name="Please Enter Valid Name"
    }else if(!(rcsCampaign.name.match(onlylettersRegex))){
      errors.name="Please Enter Valid Name"
    }
    
    if(!rcsCampaign?.templateid?.value){
      errors.templateid="Please Select Template"
    }
    if(!rcsCampaign?.senderid?.value){
      errors.senderid="Please Select Sender Id"
    }
    if(!rcsCampaign.file){
      errors.file="Please Upload File "
    }
    return errors;
   }


  const chooseFile = (e) => {
    let a = e.target.value.split(".");

    if (a[1] == "xlsx" || a[1] == "csv") {
      setValidation({
        isvalid: false,
        message: " ",
      });
      setRcsCampaign({ ...rcsCampaign, file: e.target.files[0]});
    } else {
      setValidation({
        isvalid: true,
        message: "Not Supported " + a[1] + " format",
      });
    }
  };

  
  
  return (
    
    <>
   
      <div className="content">
      <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
      <NotificationAlert ref={notificationAlertRef} />
        <Row>
          
      <Col md="12" className='pt-2'>
            <Card>
              
        
              <CardBody>
                <Form action="#">
                <Row>
                <Col md="3" sm='12'>
                    <label>Name *</label>
                    <FormGroup>
                      <Input type="Text" placeholder='Enter Name' value={rcsCampaign.name} onChange={(e) =>setRcsCampaign({...rcsCampaign,name:e.target.value})} />
                    </FormGroup>
                    {errorhandle?.name&&<span style={{color:"red"}}>{errorhandle?.name}</span>}
                  </Col>
                  <Col md="3" sm='12'>
                  <p className="category">Select Date & Time *</p>
                  <FormGroup>
                  <ReactDatetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date & Time"
                    }}
                    closeOnSelect={true}
                    timeFormat={true}
                    value={rcsCampaign.date}
                    onChange={(val) =>setRcsCampaign({...rcsCampaign,date:val._d})}
                  />
                </FormGroup>
                  </Col>
              

                    <Col md="3" sm="12">
          <p className="category">Select Template<suf style={{color:"red"}}>*</suf> </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="templateSelect"
            value={rcsCampaign.templateid}
            onChange={(value) => changeSender(value)}
            options={templates}
            placeholder="Select"
          />
          {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
        </Col>
        <Col md="3" sm="12">
          <p className="category">Select Sender</p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="senderSelect"
            value={rcsCampaign?.senderid}
            onChange={(value) => setRcsCampaign(prev=>({...prev,senderid:value}))}
            options={senderids}
            placeholder="Select"
          />
           {errorhandle?.senderid&&<span style={{color:"red"}}>{errorhandle?.senderid}</span>}
        </Col> 
        <Col md="3" sm="12">
                      <Label>Message Text</Label>
                      <Input
                        style={{ padding: "5px", resize:"auto",maxHeight:"none" }}
                        type="textarea"
                        name="message"
                        
                        value={rcsCampaign?.message}
                        placeholder="Message Text"
                        onChange={(e) => {
                          setRcsCampaign({
                            ...rcsCampaign,
                            message: e.target.value,
                          });
                        }}
                      />
                      {/* {errorhandle?.message && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.message}
                        </span>
                      )} */}
                    </Col>
                    <Col sm="3" className="mb-2 mt-2">
                      <div className="d-flex align-items-center">
                        <span className="mr-2">Group </span>
                        <CustomInput
                          type="switch"
                          id="switch-5"
                          className="mt-n4"
                          checked={ismanual===0?true:false}
                          //checked={isActive.current}
                          onChange={(e) =>{
                          
                             setIsManual(e.target.checked==true?0:1)
                            }
                            }
                        />
                        <span className="ml-n2">File</span>
                      </div>
                    </Col>
       
        {error.iserror&&<h6 style={{color:"red"}}>{error.errorhandle}</h6>}
                 
               
                    {
                        ismanual==0?<Col md="3" sm="12" className="">
                          <Label>
                            Bulk Upload (<b>Upload CSV File</b>)
                          </Label>
    
                          <FormGroup>
                            <Input
                              placeholder="placeholder"
                              accept=".csv"
                              onChange={(e) => chooseFile(e)}
                              type="file"
                              style={{
                                opacity: "1",
                                position: "initial",
                                border: "solid 1px #eee",
                              }}
                            />
                          <a href={SampleCSV} download ="rcs Sample File">  <p style={{marginLeft:"40%",color:"#e14eca"}}>*Download sample csv file</p></a>
                          </FormGroup>
                         
                            <span style={{ color: "red" }}>
                              {errorhandle?.file}
                            </span>
                         
                        </Col>:
                               <Col md="3" sm="12">
                               <p className="category">Contact Groups</p>
                               <Select
                                 className="react-select info"
                                 classNamePrefix="react-select"
                                 name="groupSelect"
                                // value={rcsCampaign.templateid}
                                // onChange={(value) => changeSender(value)}
                                 options={groups}
                                 placeholder="Select"
                               />
                               {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
                             </Col>
                    }
           
                    
                    <Col md="3" className="mb-2 ">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={iscalbck}
                            value={iscalbck}
                            onClick={(e) => {
                              e.target.checked === true
                              ? setiscalbck(true)
                              : setiscalbck(false);
                            }}
                          />
                          <span className="form-check-sign" />
                          Fall back
                        </Label>
                      </FormGroup>
                    </Col>
                    </Row>
                    {iscalbck && (
                    <>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 1</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            // value={.smsSlct}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority1");
                              //setRcsCampaign({...rcsCampaign,priority1.channel: value});
                             //  setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,channel:value}}))
                            }}
                            options={channels}
                            placeholder="Select Channel"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={rcsCampaign?.priority1?.templateid}
                            onChange={(value) => {
                              setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,templateid:value}}))
                            
                               fetchSenderId(value,rcsCampaign.priority1.channel)
                            }}
                             options={rcsCampaign?.priority1?.channel=="Email"?emailtemplates:rcsCampaign?.priority1?.channel=="IVR"?ivrtemplates:rcsCampaign?.priority1?.channel=="SMS"?smstemplates:rcstemplates}
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={rcsCampaign?.priority1?.senderid}
                        onChange={(value) => {
                          setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,senderid:value}}))
                        }}
                        options={rcsCampaign?.priority1?.channel=="Email"?emailsenderids:rcsCampaign?.priority1?.channel=="IVR"?ivrsenderids:rcsCampaign?.priority1?.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 2</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority2");
                              
                              //setRcsCampaign({...rcsCampaign,priority1.channel: value});
                               //  setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={rcsCampaign?.priority2?.templateid}
                            onChange={(value) => {
                              setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,templateid:value}}))
                            
                              fetchSenderId(value,rcsCampaign.priority2.channel)
                           
                            }}
                            // options={selectType}
                            options={rcsCampaign?.priority2?.channel=="Email"?emailtemplates:rcsCampaign?.priority2?.channel=="IVR"?ivrtemplates:rcsCampaign?.priority2?.channel=="SMS"?smstemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={rcsCampaign?.priority2?.senderid}
                        onChange={(value) => {
                          setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,senderid:value}}))
                        }}
                        options={rcsCampaign?.priority2?.channel=="Email"?emailsenderids:rcsCampaign?.priority2?.channel=="IVR"?ivrsenderids:rcsCampaign?.priority2?.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 3</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority3");
                              //setRcsCampaign({...rcsCampaign,priority1.channel: value});
                             //  setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={rcsCampaign?.priority3?.templateid}
                            onChange={(value) => {
                              setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,templateid:value}}))
                            
                              fetchSenderId(value,rcsCampaign.priority3.channel)
                            }}
                            options={rcsCampaign?.priority3?.channel=="Email"?emailtemplates:rcsCampaign?.priority3?.channel=="IVR"?ivrtemplates:rcsCampaign?.priority3?.channel=="SMS"?smstemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={rcsCampaign?.priority3?.senderid}
                        onChange={(value) => {
                          setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,senderid:value}}))
                        }}
                        options={rcsCampaign?.priority3?.channel=="Email"?emailsenderids:rcsCampaign?.priority3?.channel=="IVR"?ivrsenderids:rcsCampaign?.priority3?.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 4</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority4");
                              //setRcsCampaign({...rcsCampaign,priority1.channel: value});
                             //  setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign.priority4,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={rcsCampaign?.priority4?.templateid}
                            onChange={(value) => {
                              setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign?.priority4,templateid:value}}))
                            
                              fetchSenderId(value,rcsCampaign.priority4.channel)
                             }}
                            options={rcsCampaign?.priority4?.channel=="Email"?emailtemplates:rcsCampaign?.priority4?.channel=="IVR"?ivrtemplates:rcsCampaign?.priority4?.channel=="SMS"?smstemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={rcsCampaign?.priority4?.senderid}
                        onChange={(value) => {
                          setRcsCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign.priority4,senderid:value}}))
                        }}
                        options={rcsCampaign?.priority4?.channel=="Email"?emailsenderids:rcsCampaign?.priority4?.channel=="IVR"?ivrsenderids:rcsCampaign?.priority4?.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                    </>
                  )}
        <Row>
                   
                    <Col md="1" sm="12">
                      <Button
                        color="primary pull-right"
                        className="mt-4 btn btn-icon animation-on-hover"
                        id="tooltipsubmit"
                        type="button"
                        disabled={isLoading===true&&"true"}
                        onClick={() => submitWhatsapp()}
                      >
                        <i
                          className="tim-icons icon-double-right"
                          
                        />
                      </Button>
                     
                    </Col>
                 
                  
              </Row>
                
                </Form>
              </CardBody>
              
            </Card>
          </Col>
          <Col md="3"></Col>
          </Row>
      </div>
    </>
  )
}

export default Createcampaigns
